import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import ProgressButton from "react-progress-button";
import utils from "@utils";
import { withMsal } from "@azure/msal-react";
import { ENV_OPTIONS, ROUTES, USER_TYPE } from "@constants";
import { ADOPERATIONS } from "@constants/index";
import { connect } from "react-redux";
import UserService from "@services/UserService";
import Modal from "../Modal/Modal";

import "./ImpersonateModal.scss";

class ImpersonateModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loginButton: "",
			userId: "",
		};
	}

	componentDidUpdate(prevProps) {
		const { userIdFromList } = this.props;
		if (userIdFromList !== prevProps.userIdFromList) this.handleUserIdProp();
	}

	/** If the `userIdFromList` prop is specified, sets the value of the input to automatically contain that user Id */
	handleUserIdProp = () => {
		const { userIdFromList } = this.props;
		this.setState({ userId: userIdFromList });
	};

	/**
	 * Updates the value of the User ID text field
	 * @param {Event} event The HTML event handled by this input
	 */
	updateUserId = ({ target: { value } }) => {
		this.setState({ userId: value.replace(/\D/g, "") });
		this.setState({ loginButton: "" });
	};

	onCancel = () => {
		const { toggleModal, userIdFromList } = this.props;
		this.setState(
			{
				loginButton: "",
				userId: userIdFromList || "",
			},
			toggleModal,
		);
	};

	getUser = userId => {
		const { lang } = global;

		return UserService.getUser(userId)
			.then(({ data }) => data)
			.catch(() => {
				utils.notify({
					type: "error",
					message: lang.t("The specified user was not found"),
				});
				this.setState({ loginButton: "error" });
			});
	};

	ADImpersonateOnRollKallPortal = userEmail => {
		const { user, toggleModal } = this.props;
		if (!userEmail) {
			setTimeout(() => {
				this.setState({ loginButton: "error" });
				clearTimeout();
			}, 400);
			return;
		}

		this.setState({ loginButton: "success" });

		const queryParams = new URLSearchParams({
			loginHint: user.Email,
			impersonatedUserEmail: userEmail,
		}).toString();

		// Open the RollKall portal in a new tab
		window.open(`${ROUTES.rollkallPortalSilentImpersonate}?${queryParams}`, "_blank");

		// Close the modal
		toggleModal();
	};

	ADImpersonate = () => {
		const { userId } = this.state;
		const {
			user,
			msalContext: { instance: msalInstance },
		} = this.props;

		this.getUser(userId).then(data => {
			/**
			 * If the user is an officer or client, impersonate on the
			 * RollKall portal.
			 */
			if ([USER_TYPE.OFFICER, USER_TYPE.CLIENT].includes(data.UserTypeId)) {
				this.ADImpersonateOnRollKallPortal(data.Email);
				return;
			}

			msalInstance.loginRedirect({
				authority: ENV_OPTIONS.adb2c.policies.impersonate,
				scopes: ENV_OPTIONS.adb2c.scopes,
				redirectUri: ROUTES.ADCallback,
				state: utils.encodeADState({ operation: ADOPERATIONS.impersonate }),
				loginHint: user.Email,
				extraQueryParameters: {
					impersonatedUserEmail: data.Email.replace(/\+/g, "%2B"),
					uxConfig: utils.encodeADState({ disabledInputs: ["email"] }),
				},
			});
			this.setState({ loginButton: "success" });
		});
	};

	/**
	 * Makes the API request to impersonate another user as a Super Admin. If a client is being impersonated,
	 * the user will be redirected to the client portal that uses the current user's environment.
	 * */
	onSubmit = () => {
		const { userId } = this.state;

		this.setState({ loginButton: "loading" });

		if (!userId) {
			setTimeout(() => {
				this.setState({ loginButton: "error" });
				clearTimeout();
			}, 400);
			return;
		}

		this.ADImpersonate();
	};

	render() {
		const { lang } = global;
		const { show } = this.props;
		const { userId, loginButton } = this.state;

		return (
			<Modal
				size="sm"
				show={show}
				id="impersonate-modal"
				onHide={this.onCancel}
				onEntered={() => this._idField.focus()}
			>
				<Modal.Header closeButton>
					<Modal.Title>{lang.t("Impersonate User")}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div
						className={classNames("form-group", {
							"has-error": loginButton === "error",
						})}
					>
						<input
							className="form-control"
							name="userId"
							id="userId"
							placeholder={lang.t("Enter User ID")}
							value={userId}
							onChange={this.updateUserId}
							onKeyPress={event => {
								if (event.key === "Enter") this.onSubmit();
							}}
							ref={ref => {
								this._idField = ref;
							}}
						/>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button
						type="button"
						className="btn btn-default"
						onClick={this.onCancel}
					>
						{lang.t("Cancel")}
					</button>
					<ProgressButton
						id="impersonate-login"
						className="btn btn-primary"
						state={loginButton}
						onClick={this.onSubmit}
					>
						{lang.t("Login")}
					</ProgressButton>
				</Modal.Footer>
			</Modal>
		);
	}
}

const mapStateToProps = ({ app: { user } }) => ({
	user,
});

ImpersonateModal.propTypes = {
	user: PropTypes.object.isRequired,
	show: PropTypes.bool.isRequired,
	toggleModal: PropTypes.func.isRequired,
	userIdFromList: PropTypes.any,
	msalContext: PropTypes.object.isRequired,
};

ImpersonateModal.defaultProps = {
	userIdFromList: "",
};

export default withMsal(connect(mapStateToProps, null)(ImpersonateModal));
